import {
  ApplicationRef,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  ElementRef,
  EventEmitter,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SelectionModeList, SreachModeList } from '@barthauer/abc/ui-components';
import { DataSource, ArrayStore } from 'devextreme/common/data';
import { DataService } from '../../services/data.service';

import { FavoriteFilterListComponent } from './favorite-filter-list/favorite-filter-list.component';
import { FavoritesService } from './favorites.service';
import { BoxDetailViewModel, TypeFavorite } from './Model/box.viewModel';
import { Subject } from 'rxjs';
import { first, take, takeUntil } from 'rxjs/operators';
import { LanguageService } from '../../services/language.service';
import { DxListComponent } from 'devextreme-angular';
import { log } from 'node:console';

@Component({
  selector: 'favorites',
  templateUrl: './favorites.component.html',
  styleUrls: ['./favorites.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false
})
export class FavoritesComponent implements OnInit, OnDestroy {
  @ViewChild(DxListComponent) dxList: DxListComponent;
  @Output() onItemClicked: EventEmitter<any> = new EventEmitter();
  @Input() ObjectTypeNames;
  @Input() appObjectTypesKeys: string[];
  public ComponentRef: ComponentRef<FavoriteFilterListComponent>;
  public favoriteData: BoxDetailViewModel[];
  public dataSource: DataSource;
  public sreachModeList = SreachModeList.Contains;
  public selectionModeList = SelectionModeList.Single;
  private filterList: Map<string | number, any>;
  public islistOpened: boolean = false;
  public showLoader: boolean;
  private destroy$ = new Subject<void>();

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private elementRef: ElementRef,
    private favoritesService: FavoritesService,
    private injector: Injector,
    private resolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    public dataService: DataService,
    private cdRef: ChangeDetectorRef
  ) {
    this.initializeFavorites();
    this.registerIcons();
  }

  ngOnInit(): void {
    this.showLoader = true;
    if (this.favoritesService.favorites$ === null) {
      this.favoritesService.initial();
    }
    
    if (Array.isArray(this.appObjectTypesKeys) && this.appObjectTypesKeys.length > 0) {
      this.favoritesService.appObjectTypesKeys = this.appObjectTypesKeys;
    }
    this.loadFavorites();
  }
  private loadFavorites(): void {
    this.favoritesService.favorites$.pipe(takeUntil(this.destroy$)).subscribe((favoriteList) => {
      if (favoriteList?.favorites) {
        this.favoriteData = Array.from(favoriteList.favorites.values());

        const filetredData = this.favoriteData.filter((favorite) => favorite?.DisplayText != undefined);
        this.fillDataSource(filetredData);
      }
    });
  }

  private registerIcons(): void {
    const icons = [
      { name: 'fav', url: 'assets/images/all_favorites.svg' },
      { name: 'company', url: 'assets/images/company_fav.svg' },
      { name: 'audAudit', url: 'assets/images/audit_fav.svg' },
      { name: 'audBibMeasure', url: 'assets/images/measure.svg' },
      { name: 'audBibResponse', url: 'assets/images/answer.svg' },
      { name: 'MeasureTask', url: 'assets/images/question.svg' },
      { name: 'audLibrary', url: 'assets/images/library.svg' },
      { name: 'audBibCategory', url: 'assets/images/category.svg' },
      { name: 'subProject', url: 'assets/images/subProject.svg' },
      { name: 'measure', url: 'assets/images/measure.svg' },
    ];

    icons.forEach((icon) => {
      this.iconRegistry.addSvgIcon(icon.name, this.sanitizer.bypassSecurityTrustResourceUrl(icon.url));
    });
  }
  private initializeFavorites(): void {
    this.favoritesService
      .getDataSource()
      .pipe(take(1))
      .subscribe(() => { });
  }
  private fillDataSource(listFavorites: BoxDetailViewModel[]): void {
    if (listFavorites.length > 0) {
      listFavorites = listFavorites.filter((favorite) => {
        if (this.ObjectTypeNames[favorite.ParentObjectType] !== undefined) {
          return favorite;
        }
      });
    }
    this.filterList = this.fillObjectTypeName(listFavorites);
    if (this.dataSource) {
      this.dataSource.dispose();
    }
    this.dataSource = new DataSource({
      store: new ArrayStore({
        data: [...listFavorites],
        key: 'ParentObjectType', // stable key
      }),
      sort: ['DisplayText', ' key'],
      group: 'ParentObjectTypeName',
      searchExpr: ['DisplayText', 'ParentObjectTypeName'],
    });

    this.showLoader = false;

  }

  private fillObjectTypeName(listFavorites: BoxDetailViewModel[]): Map<string | number, any> {
    const filterList: Map<string | number, any> = new Map<string | number, any>();
    filterList.set('All', { Name: 'All', Icon: 'fav', parentObjectType: null });
    if (listFavorites.length > 0) {
      listFavorites.forEach((favorite) => {
        if (this.ObjectTypeNames[favorite.ParentObjectType] !== undefined) {
          if (!filterList.has(favorite.ParentObjectType)) {
            filterList.set(this.ObjectTypeNames[favorite.ParentObjectType], {
              Name: this.ObjectTypeNames[favorite.ParentObjectType],
              parentObjectType: favorite.ParentObjectType,
              Icon: TypeFavorite[this.ObjectTypeNames[favorite.ParentObjectType]],
            });
          }

          favorite.ObjectType = favorite.ParentObjectType;

          favorite.ParentObjectTypeName = this.dataService.res(
            'Favorites-' + this.ObjectTypeNames[favorite.ParentObjectType]
          );
        }
      });
    }

    return filterList;
  }

  private createComponent(): void {
    const compFactory = this.resolver.resolveComponentFactory(FavoriteFilterListComponent);
    this.ComponentRef = compFactory.create(this.injector, undefined, '#forViewRef');
    this.appRef.attachView(this.ComponentRef.hostView);

    const filterList = this.ComponentRef.instance;
    filterList.filteredBy = 'All';
    filterList.filterList = this.filterList;    
    filterList.onButtonClick.subscribe((eventText) => {

      let objectTypeId: number | null = null;

      for (const [key, value] of this.filterList.entries()) {
        if (value.Name === eventText) {
          objectTypeId = value.parentObjectType ?? null;
          break;
        }
      }

      filterList.filteredBy = eventText;
      this.onFilterListClicked(objectTypeId);
    });
  }

  private onFilterListClicked(objectTypeId: number | null): void {
    if (objectTypeId !== null) {
      this.dataSource.filter(['ParentObjectType', '=', objectTypeId]);
    } else {
      this.dataSource.filter(null); // "All"
    }
    this.dataSource.load();
  }


  public contentReady(): void {    
    if (!this.islistOpened) {
      this.islistOpened = true;
      const listBoxContent = this.elementRef.nativeElement.querySelector('.dx-scrollview-content');
      const parent = document.createElement('div');
      parent.className = 'filterList';
      parent.setAttribute('id', 'forViewRef');
      listBoxContent.appendChild(parent);
      listBoxContent.insertAdjacentElement('beforebegin', parent);
      this.createComponent();
    }
  }

  public itemClicked(event: any): void {
    this.onItemClicked.emit(event);
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.cdRef.detach();
  }
}
